// Ficha de producto: el precio grande sigue a la cantidad elegida.
//
// Es una mejora encima de HTML que ya funciona. Sin este archivo la ficha se
// usa igual: los radios son nativos, el formulario es el de Shopify y el
// carrito recibe la variante correcta. Lo único que se pierde es que el importe
// de arriba se quede en el de la primera opción.
//
// El importe NO se calcula aquí: se copia del que ya escribió Liquid en cada
// radio, que viene del precio real de Shopify. Multiplicar en el navegador
// sería una segunda fuente de verdad y acabaría enseñando algo distinto de lo
// que se cobra.

document.addEventListener('change', (ev) => {
  const radio = ev.target.closest('.opciones input[type=radio]');
  if (!radio) return;
  const destino = radio.closest('.ficha')?.querySelector('[data-precio]');
  const precio = radio.dataset.opcionPrecio;
  if (destino && precio) destino.textContent = precio;
});
